// extracted by mini-css-extract-plugin
export default {"container":"eventDetails_container__OT08W","eventDetails":"eventDetails_eventDetails__OKstA","BackButton":"eventDetails_BackButton__gliCq"};